import type { HttpMethod } from "openapi-typescript-helpers";

export class ApiError extends Error {
  readonly status: number;
  readonly endpoint: string;
  readonly method: HttpMethod;
  readonly body: unknown;

  constructor(response: Response, method: HttpMethod, body: unknown) {
    super(`${response.status} ${response.statusText}`);
    this.name = "ApiError";
    this.status = response.status;
    this.endpoint = response.url;
    this.method = method;
    this.body = body;
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}
